<template>
  <ViewCustomRow @refreshRow="refreshRow" @addNewRow="addNewRow" v-model:showRowDialog="showDialog" :rowId="rowId"
    :permissions="permissions" :masterDetail="masterDetail" :dialogOptions="dialogOptions" :entityKey="entityKey"
    @hide="dictionaryReport.tasks = []" entityName="report" entitySpec="data" :requiredFields="{
      report_name: true,
      report_sysname: true,
      report_code: true,
      module_id: true,
      task_id: true,
    }" :dictionary="REPORT_DICTIONARY">
    <template #header="{ rowData }">
      <label data-testid="header_report">{{
        rowId === -1
          ? 'Новый отчёт'
          : `Редактирование отчёта № ${rowId} ${rowData ? rowData.report_name : ''
          }`
      }}</label>
    </template>
    <template #body="{ rowData, reference, submitted }">
      <div class="formgrid grid align-items-center vertical-container mt-3">
        <div class="col-2">
          <label for="report_name" class="mb-1">Наименование:</label>
        </div>
        <div class="col-4">
          <InputText id="report_name" v-model.trim="rowData.report_name" :class="{
            'p-invalid': submitted ? (rowData.report_name || '') == '' : false,
          }" />
        </div>

        <div class="col-2">
          <label for="report_sysname">Системное имя:</label>
        </div>
        <div class="col-4">
          <InputText id="report_sysname" v-model.trim="rowData.report_sysname" :class="{
            'p-invalid': submitted ? (rowData.report_sysname || '') == '' : false,
          }" />
        </div>
      </div>
      <div class="formgrid grid align-items-center vertical-container mt-3">
        <div class="col-2">
          <label for="report_param_type_id" class="mb-1">Входные параметры:</label>
        </div>
        <div class="col-4">
          <Dropdown id="report_param_type_id" :modelValue="rowData.report_param_type_id" disabled
            :options="reference['report_param_type']" optionLabel="report_param_type_name"
            optionValue="report_param_type_id" appendTo="body" />
        </div>

        <div class="col-2">
          <label for="module_id" class="mb-1">Модуль:</label>
        </div>
        <div class="col-4">
          <Dropdown id="module_id" v-model="rowData.module_id" :options="modules" filter optionLabel="module_name"
            optionValue="module_id" appendTo="body" @change="onChangeModule(rowData)" :class="{
              'p-invalid': submitted ? (rowData.module_id || '') == '' : false,
            }" />
        </div>
      </div>
      <div class="formgrid grid align-items-center vertical-container mt-3">
        <div class="col-2">
          <label for="task_id" class="mb-1">Задача:</label>
        </div>
        <div class="col-4">
          <Dropdown id="task_id" v-model="rowData.task_id" :options="dictionaryReport.tasks" optionLabel="task_name"
            filter optionValue="task_id" appendTo="body" :class="{
              'p-invalid': submitted ? (rowData.task_id || '') == '' : false,
            }" />
        </div>
        <div class="col-2">
          <label for="report_code">Код:</label>
        </div>
        <div class="col-2">
          <Dropdown id="report_code" v-model="rowData.report_code" :options="dictionaryReport.reportCode"
            optionLabel="report_code" optionValue="report_code" appendTo="body" :class="{
              'p-invalid': submitted ? (rowData.report_code || '') == '' : false,
            }" />
        </div>
        <div class="col-2">
          <InputText id="report_code" v-model.trim="rowData.report_struct_code" disabled />
        </div>
      </div>
      <div class="formgrid grid align-items-center vertical-container mt-3">
        <div class="col-2">
          <label for="report_desc" class="mb-1">Описание:</label>
        </div>
        <div class="col-10">
          <Textarea id="report_desc" v-model="rowData.report_desc" required rows="2" cols="20" />
        </div>
      </div>
      <TabView>
        <TabPanel header="Шаблоны">
          <ViewCustomData entityName="report_template" entitySpec="report" serviceName="BaseService"
            :columns="reportTemplateColumns" :masterDetail="{ report_id: rowId }" :dialogOptions="{
              numberTemplates: reportTemplateRef?.data?.length ?? 0,
              reportName: rowData.report_name,
            }" ref="report_template" :paginator="false" :dialog="templateDialog" />
        </TabPanel>
        <TabPanel header="Аудит">
          <ViewCustomData entityName="log_report" entitySpec="data" serviceName="BaseService" :columns="AUDIT_COLUMNS"
            scrollHeight="440px" :masterDetail="{ report_id: rowId }" :paginator="false"
            :visibleButtons="{ insert: false, edit: false, delete: false }" :toolbarFilters="AUDIT_TOOLBAR_FILTER" />
        </TabPanel>
      </TabView>
    </template>
  </ViewCustomRow>
</template>

<script>
import { ref, reactive, shallowRef, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { ViewCustomRow } from 'cdisoft-library';
import TemplateDialog from './TemplateDialog';
import { REPORT_DICTIONARY, REPORT_TEMPLATE_COLUMNS, AUDIT_COLUMNS, AUDIT_TOOLBAR_FILTER } from './reportConstants';

export default {
  name: 'ReportDialog',
  mixins: [ViewCustomRow],
  setup() {
    const store = useStore();
    const router = useRouter();

    const templateDialog = shallowRef(TemplateDialog);
    const dictionaryReport = reactive({
      reportCode: [],
      tasks: [],
    });
    const reportTemplateRef = ref(null);

    const info = computed(() => store.getters.info);
    const password = computed(() => store.getters.password);
    const nameToService = computed(() => store.getters.nameToService);
    const modules = computed(() => store.getters.modules);

    let reportCodeService = null;
    let taskService = null;

    const initServices = () => {
      if (!nameToService.value) return;
      if (!reportCodeService) {
        reportCodeService = nameToService.value(
          'BaseService',
          info.value.login,
          password.value,
          'report_code',
          'ref'
        );
      }
      if (!taskService) {
        taskService = nameToService.value(
          'BaseService',
          info.value.login,
          password.value,
          'task',
          'ref'
        );
      }
    };


    onMounted(() => {
      initServices();
    });

    const reportTemplateColumns = computed(() => {
      return [
        ...REPORT_TEMPLATE_COLUMNS,
        {
          header: '',
          field: '',
          headerStyle: 'width: 2rem',
          bodyStyle: 'text-align: center;overflow: visible',
          dataType: 'component',
          configComponents: [
            {
              name: 'button',
              attrList: {
                icon: 'pi pi-cog',
                class: 'mr-1',
              },
              funcName: 'designReport',
              componentFunction: (data) => {
                if (!info.value?.isAdmin) {
                  store.commit('SET_ERROR', {
                    er: 'Недостаточно прав',
                  });
                  return;
                }
                const route = router.resolve({
                  name: 'report-designer',
                  params: { id: data.report_template_id },
                });
                window.open(route.href, '_blank');
              },
            },
          ],
        },
      ];
    });

    const onChangeModule = (rowData, clearTask = true) => {
      if (clearTask) {
        rowData.task_id = null;
        rowData.report_struct_code = null;
      }
      if (taskService) {
        taskService
          .getData({ module_id: rowData.module_id })
          .then((data) => {
            dictionaryReport.tasks = data;
          })
          .catch((er) => store.commit('SET_ERROR', { er }));
      }
      if (reportCodeService) {
        reportCodeService
          .getData({ module_id: rowData.module_id, report_id: rowData.report_id })
          .then((data) => {
            dictionaryReport.reportCode = data;
          })
          .catch((er) => store.commit('SET_ERROR', { er }));
      }
    };

    const prepareData = (rowData) => {
      onChangeModule(rowData, false);
      return rowData;
    };

    const beforeOpenNewRow = (rowData) => {
      rowData.report_param_type_id = 24001;
    };

    const prepareInsert = (rowData) => {
      dictionaryReport.tasks = [];
      return prepareUpdate(rowData);
    };

    const prepareUpdate = (rowData) => {
      const data = {
        report_id: rowData.report_id,
        module_id: rowData.module_id,
        report_code: rowData.report_code,
        report_desc: rowData.report_desc || null,
        report_name: rowData.report_name,
        report_param_type_id: rowData.report_param_type_id,
        report_sysname: rowData.report_sysname,
        task_id: rowData.task_id,
      };
      return data;
    };

    return {
      templateDialog,
      dictionaryReport,
      reportTemplateRef,

      modules,
      reportTemplateColumns,

      REPORT_DICTIONARY,
      AUDIT_COLUMNS,
      AUDIT_TOOLBAR_FILTER,

      onChangeModule,
      prepareData,
      beforeOpenNewRow,
      prepareInsert,
      prepareUpdate
    };
  },
};
</script>